import React, {useEffect, useState, useRef} from 'react';

import blankPagePlaceholder from '../../Assets/blankPagePlaceholder.svg'
import blankPageArrow from '../../Assets/blankPageArrow.svg'

import {
    rxCreationData,
    rxSideMenu,
    rxSections,
    eventEmiter,
    rxBlocks,
    rxIsLoading
} from '../../rx/rxState';

import {ReactComponent as ArrowLeft} from '../../Assets/arrow-left-white.svg';

import StyledSideMenu from './StyledSideMenu';
import {useObservable} from '../../utils/UseObservable';
import {TEMPLATES_URL} from '../../Constants';
import Modal from "../Common/Modal/Modal";
import PrimaryButton from "../Common/PrimaryButton/PrimaryButton";
import { AIGenerator, generateAIPage } from '../../page-ai-generator/generation';
// import useIsVisible  from "../../Hooks/useIsVisible";

// const ColorViewStyle = styled.div`
//   position: relative;
//   width: 50px;
//   height: 50px;
//   margin: auto;
//   border-radius: 40px;
//   background: ${(prop) => prop.color};
//   border: 5px #575757 solid;
// `;
//
// const FocusColorStyle = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 80px;
//   position: absolute;
//   bottom: 10px;
//   left: 0px;
//   z-index: 2001;
// `

const SideMenu = () => {
    const menuItems = useObservable(rxSideMenu);
    const sections = useObservable(rxSections);
    // const accentColor = useObservable(rxAccentColor);
    const [activeMenu, setActiveMenu] = useState(null);
    const [countItemSubMenu,setCountItemSubMenu] = useState(1);    //current count of items in submenu
    // const [displayColorPicker, setDisplayColorPicker] = useState(false);

    const [preload, setPreload] = useState(false);
    const [isTutorialActive, setIsTutorialActive] = useState(false);

    const subMenuRef = useRef();
    const endSubMenuRef = useRef();
    let subMenuLength = 0;

    const handleClickMenu = (i) => {
        setActiveMenu(i);
        setTimeout(500, () => eventEmiter.next({type: 'update-view'})) // trigger view updated after .5 seconds. this is how long side menu transition
    }

    const handleCloseSubMenu = () => {
        setActiveMenu(null);
        setTimeout(500, () => eventEmiter.next({type: 'update-view'})) // trigger view updated after .5 seconds. this is how long side menu transition
    }


    /**
     * 1. Render/Load items during initial page load.
     * 2. Then render/load next set of items only in case if viewport height can't contain all existing items during the scrolling.
     * */
    const subMenuAddItem = () => {
        if (menuItems && menuItems.length > 0 && menuItems[activeMenu]) {
            subMenuLength = menuItems[activeMenu].items.length;
            if(subMenuRef.current && endSubMenuRef.current && countItemSubMenu + 1 <= subMenuLength) {
                const bottomSubMenuRef = subMenuRef.current.getBoundingClientRect().bottom;
                const topEndSubMenuRef = endSubMenuRef.current.getBoundingClientRect().top;

                if(topEndSubMenuRef - 10 < bottomSubMenuRef) {
                    setCountItemSubMenu(countItemSubMenu + 5)
                }
            }
        }
    };

    //Here add item while we have all of them on the page or the items get the end of the page
    useEffect(() => {
        subMenuAddItem()
    })

    useEffect(() => {
        const getEditorStatus = () => localStorage.getItem('wasEditorVisited');
        const setEditorStatus = (value) => localStorage.setItem('wasEditorVisited', value);

        if (menuItems && menuItems.length > 0 && preload === false) {
            if (getEditorStatus() === null) {
                handleClickMenu(0);
                setIsTutorialActive(true);
                setEditorStatus(true);
            }
        }
    })

    useEffect(() => {
        if (menuItems && menuItems.length > 0 && preload === false) {

            setPreload(true);

            for (let menu of menuItems) {
                let i = 0;
                for (let section of menu.items) {
                    if (i > 30) {
                        break;
                    }
                    i++;
                    if (section.image !== undefined) {
                        let src = `${TEMPLATES_URL}/${section.image}`
                        let img = new Image();
                        img.src = src;
                        //console.log(`preloading(${i}): `, src);
                    }
                }
            }
        }
    })

    /** Render component in case if user change his activeMenu. For example Text -> Image -> Tools */
    // useEffect(() => {
    //     setCountItemSubMenu(1)
    // },[activeMenu])

    /**
     * TODO: that function is workaround.
     * We need it for the useEffect above, otherwise it won't work.
     * */
    useEffect(() => {
        setCountItemSubMenu(countItemSubMenu + 1)
    },[])

    const onDragStart = (event) => {
        var img = new Image();
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
        event.dataTransfer.setDragImage(img, 0, 0);

        let blockType = 'section';
        let data;
        const id = event.currentTarget.id;
        sections.forEach(section => {
            if (section._id === id) {
                data = section.data;
            }
        })
        if (Object.keys(data).length === 0) {
            return;
        }

        rxCreationData.next({
            section: id,
            data,
            blockType,
        });

    }

    const onDragEnd = (event) => {
        if (event.dataTransfer.dropEffect === 'none') {
            //Drop got Canceled
            rxCreationData.next({
                blockType: null
            })
        }
    }

    const generateSubMenu = () => {
        if (activeMenu === null) {
            return;
        }
        const subMenu = menuItems[activeMenu].items;
        if (!subMenu || !subMenu.length) {
            return;
        }

        const subMenuAllList = subMenu.map((subItem, i) => {
            if (subItem.type === 'action' || subItem.type === 'section') {
                return (
                    <div
                        className="submenu-item action"
                        key={`section-${activeMenu}-${i}`}
                        id={subItem._id}
                        draggable="true"
                        onDragStart={(e) => onDragStart(e)}
                        onDragEnd={(e) => onDragEnd(e)}
                    >
                        <div className="image">
                            {/* {subItem._id}
                            <div>{subItem.name}</div> */}
                            <img draggable='false' src={`${TEMPLATES_URL}/${subItem.image}`} alt="menu item"/>
                        </div>
                    </div>
                )
            }
            if (subItem.type === 'devider') {
                return (
                    <div
                        className="submenu-item devider"
                        key={`devider-${i}`}
                    >
                        <h4 className="label">
                            {subItem.label}
                        </h4>
                    </div>
                )
            }
            return null;
        });

        subMenuLength = subMenuAllList.length;
        const subMenuRender = subMenuAllList.slice(0,countItemSubMenu);
        return subMenuRender
    }

    const filterMenuItems = (items) => {
        return items;
        // return items.filter(item => showExitModal ? !item.onlyRegular : true);
    }

    // const color = '#65d643';

    // const changeColorByPicker = (value) => {
    //   rxAccentColor.next(value.hex);
    // }
    // const onClose = () => {
    //   setDisplayColorPicker(false);
    // };
    // const onColorClick = () => {
    //   setDisplayColorPicker(!displayColorPicker);
    // };
    // const popover = {
    //   position: 'absolute',
    //   bottom: '50px',
    //   zIndex: '2005'
    // };
    //
    // const cover = {
    //   position: 'fixed',
    //   top: '0px',
    //   right: '0px',
    //   bottom: '0px',
    //   left: '0px',
    // };

    return (
        <>
            <StyledSideMenu>
                {menuItems && <div className={'menu'}>
                    {filterMenuItems(menuItems).map((menuItem, i) => (
                        <div
                            key={i}
                            className={activeMenu === i ? "menu-item active" : "menu-item"}
                            onClick={() => handleClickMenu(i)}
                        >
                            <div className={'image'}>
                                <img src={`${TEMPLATES_URL}/${menuItem.image}`} alt="menu item"/>
                            </div>
                            <div className={'label'}>
                                {menuItem.name}
                            </div>
                        </div>
                    ))}
                </div>}
                <div
                    onScroll={subMenuAddItem}
                    className={`${activeMenu !== null ? "active" : ''} sub-menu`}
                    ref={subMenuRef}
                >
                    <div>
                        {generateSubMenu()}
                        <div ref={endSubMenuRef}></div>
                    </div>
                </div>
                {activeMenu !== null &&
                <div className={'hide-sub-menu'} onClick={() => handleCloseSubMenu()}>
                    <div className={'content'}>
                        <div className="top angle">
                        </div>
                        <div className={'center'}>
                            <ArrowLeft/>
                        </div>
                        <div className={'bottom angle'}>
                        </div>
                    </div>
                </div>
                }
                <Modal displayModal={isTutorialActive}>
                    <img alt='' src={blankPageArrow} className={'blankPageArrow'}/>
                    <div className={'placeholderContainer'}>
                        <img alt='' src={blankPagePlaceholder} className={'blankPagePlaceholder'}/>
                        <p className={'blankPageText'}>
                            Would you like to to add more content? <br/>  Just drag and drop sections from the left bar into your page!
                        </p>
                    </div>
                    <div className={'blankPageButton'}>
                        <PrimaryButton height={40} width={180} onClick={() => setIsTutorialActive(false)} name={'Ok, Got It'}/>
                    </div>
                </Modal>
            </StyledSideMenu>
            {/*<FocusColorStyle>*/}
            {/*  <ColorViewStyle*/}
            {/*    onClick={() => onColorClick()}*/}
            {/*    color={accentColor}>*/}
            {/*      {displayColorPicker && (*/}
            {/*      <div style={popover}>*/}
            {/*        <div style={cover} onClick={() => onClose()} />*/}
            {/*        <GithubPicker */}
            {/*            width="190px"*/}
            {/*            colors={Colors}*/}
            {/*            triangle={'hide'}*/}
            {/*            onChange={(v) => changeColorByPicker(v)}*/}
            {/*            color={accentColor}*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*      )}*/}
            {/*  </ColorViewStyle>*/}
            {/*  <div style={{fontSize: "11px", textAlign: 'center'}}>*/}
            {/*    Focus Color*/}
            {/*  </div>*/}
            {/*</FocusColorStyle>*/}
        </>
    )
}

export default SideMenu;